import {
  EMPTY_STRING,
  authConstants,
  globalConstants,
  subscriptionConstants,
} from "../../constants";
import { setItemToStorage } from "../../system/storage";
import {
  encryptObject,
  getDecryptPayload,
  getDecryptUserRole,
} from "../../system/encryption";

const { SUCCESS, FAILURE } = globalConstants;
const { GET_USER_SUBSCRIPTION_STATUS } = subscriptionConstants;
const {
  LOGIN,
  VERIFY_EMAIL,
  UPDATE_USER_ROLE,
  UPDATE_CURRENT_USER,
  IS_NAVIGATE_TO_DEFAULT,
} = authConstants;

// initializing the token from the browser
const payload = getDecryptPayload();
const token = payload.token || EMPTY_STRING;
const role = getDecryptUserRole() || null;

const initialState = {
  isAuthenticated: token.length > 0,
  jwt: token,
  user: payload?.user || {},
  verifyUser: null,
  userRole: role,
  isNavigateToDefault: false,
};

// Update the payload with the new subscription status
const setUpdatedPayload = (payload) => {
  const data = getDecryptPayload();

  const ciphertext = encryptObject({
    ...data,
    user: {
      ...data.user,
      subscriptionStatus: payload.status,
      subscriptionPlatform: payload.platform,
    },
  });

  setItemToStorage(process.env.REACT_APP_PAYLOAD, ciphertext);
};

const setUserRoleToStorage = (role) => {
  const ciphertext = encryptObject(role);

  setItemToStorage(process.env.REACT_APP_USER_ROLE, ciphertext);
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN + SUCCESS:
      setUserRoleToStorage(action.data.user.roleIds[0]);
      return {
        ...state,
        jwt: action.data.token,
        user: action.data.user,
        userRole: action.data.user.roleIds[0],
        isAuthenticated: true,
      };
    case UPDATE_CURRENT_USER + SUCCESS:
      return {
        ...state,
        user: action.data,
      };
    case VERIFY_EMAIL + SUCCESS:
    case VERIFY_EMAIL + FAILURE:
      return {
        ...state,
        verifyUser: action.data,
      };
    case GET_USER_SUBSCRIPTION_STATUS + SUCCESS:
      setUpdatedPayload(action.data);
      return {
        ...state,
        user: {
          ...state.user,
          subscriptionStatus: action.data.status,
          subscriptionPlatform: action.data.platform,
        },
      };
    case UPDATE_USER_ROLE:
      setUserRoleToStorage(action.data);
      return {
        ...state,
        userRole: action.data,
      };
    case IS_NAVIGATE_TO_DEFAULT:
      return {
        ...state,
        isNavigateToDefault: action.data,
      };
    default:
      return { ...state };
  }
};
